module.exports = __webpack_public_path__ + "static/img/game_bg_1.6c079bdd.png";